import React from 'react'
import DivinerSighnUp from '../../components/divinerPageComponent/DivinerSighnUp'


const index = () => {
  return (
    <>
   
    <DivinerSighnUp/>
    </>
  )
}

export default index